export default __webpack_public_path__ + "static/media/Extension.916ece9c.png";